import React from "react";
import "./header.scss";

const Header = ({
  children,
  onClickButton,
  buttonTxt
}) => React.createElement("header", {
  className: onClickButton ? "appHeader appHeader_withButton" : "appHeader"
}, React.createElement("div", {
  className: "headerContent"
}, children, onClickButton && buttonTxt && React.createElement("button", {
  className: "button ghost",
  onClick: onClickButton
}, buttonTxt)));

export default Header;